// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPricesFiltersSchema {
  /** Временной интервал для оценки (полгода/год/всё время) **/
  period: EPeriod;
  /** Тип оценки (за объект/за м²) **/
  pricesType: EPricesType;
  /** Тип комнатности (Студия, 1/2/3/4+ комнатные) **/
  roomCount: ERoomCount;
}

export enum EPeriod {
  /** За всё время **/
  'AllTime' = 'allTime',
  /** За полгода **/
  'HalfYear' = 'halfYear',
  /** За год **/
  'Year' = 'year',
}
export enum EPricesType {
  /** Цена за объект **/
  'Price' = 'price',
  /** Цена за м² **/
  'PriceSqm' = 'priceSqm',
}
export enum ERoomCount {
  /** Четырехкомнатная квартира **/
  'FourRoom' = 'fourRoom',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Трехкомнатная квартира **/
  'ThreeRoom' = 'threeRoom',
  /** Двухкомнатная квартира **/
  'TwoRoom' = 'twoRoom',
}
